module.exports = __webpack_public_path__ + "static/media/vtpro4.538f9746.jpg";